import { Component, Input, OnChanges, OnInit } from "@angular/core";
import { IVehicle } from "@app/interfaces/IVehicle";
import { DeviceProfileService } from "@app/services/device-profile.service";
import './device-profile-vehicle-preview.component.scss';

@Component({
    selector: 'device-profile-vehicle-preview',
    template: require('./device-profile-vehicle-preview.component.html')
})
export class DeviceProfileVehiclePreviewComponent implements OnInit, OnChanges {

    @Input() vehicle: IVehicle;

    loading: boolean;

    constructor(
        private readonly deviceProfileService: DeviceProfileService
    ) { }

    ngOnInit() {
        this.render();
    }

    ngOnChanges() {
        this.render();
    }

    //--

    private async render(): Promise<void> {

        if (!this.vehicle) {
            return;
        }

        this.loading = true;

        const promises: Promise<any>[] = [
            this.deviceProfileService.getProfileForVehicle(this.vehicle.Id),
            this.deviceProfileService.getComparisonForVehicle(this.vehicle)
        ];

        await Promise.all(promises).then(([profile, comparison]) => {
            this.vehicle.deviceProfile = profile;
            this.vehicle.deviceParameterComparisonResult = comparison;
        })

        this.loading = false;
    }
}
